import { endpointConstants } from "../constants";
import { get } from "../../utils";

export const yodaCustomerService = {
  getAll,
  getOne,
};

function getAll(agentId, page = 1, pageSize = 10000) {
  let endpoint = endpointConstants.YODACUSTOMER.GET_ALL.replace(
    ":agentId",
    agentId,
  )
    .replace(":page", page)
    .replace(":pageSize", pageSize);
  return get(endpoint);
}

function getOne(customerId) {
  let endpoint = endpointConstants.YODACUSTOMER.GET_ONE.replace(
    ":customerId",
    customerId,
  );
  return get(endpoint);
}
